import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

function Services() {
  const [activeTab, setActiveTab] = useState('basis')

  useEffect(() => {
    const hash = window.location.hash.replace('#', '')
    if (hash && tabs.some(tab => tab.id === hash)) {
      setActiveTab(hash)
    }
  }, [])

  useEffect(() => {
    const hash = window.location.hash.replace('#', '')
    if (hash && activeTab === hash) {
      setTimeout(() => {
        const el = document.getElementById(hash)
        if (el) {
          const y = el.getBoundingClientRect().top + window.pageYOffset - 120
          window.scrollTo({ top: y, behavior: 'smooth' })
        }
      }, 100)
    }
  }, [activeTab])

  const tabs = [
    {
      id: 'basis',
      title: 'B2B – Business to Business',
      bg: 'bg-gray-50',
      border: '',
      color: 'text-blue-900',
      items: [
        'Unser Geschäft hilft Ihrem Geschäft, Lohnabrechnungen richtig abzuwickeln.',
        'Laufende Lohn‑ & Gehaltsabrechnungen (Stunden‑, Monatslöhne)',
        'Lohnsteueranmeldung (ELSTER), SV‑Meldungen (DEÜV)',
        'SEPA‑Zahlungsdateien & Überweisungen',
        'Digitale Lohnabrechnungen & Portal‑Zugriff'
      ],
      subtitle:
        'Ideal für KMU bis 10 MA – alles Wesentliche abgedeckt.'
    },
    {
      id: 'kanzlei',
      title: 'B2K – Business to Kanzlei',
      bg: 'bg-blue-50',
      border: 'border-2 border-blue-200',
      color: 'text-blue-900',
      items: [
        'Vollkompatibel mit DATEV/Agenda/Addison (CSV/XML‑Export)',
        'Mandantenschutz & Backup‑Service bei Ausfällen',
        'Jahresmeldungen, Beitragsnachweise, eAU‑Bescheinigungen',
        'Sofortmeldungen, ELStAM‑Übermittlung'
      ],
      subtitle:
        'Perfekt für Steuerkanzleien – nahtlose Integration.'
    },
    {
      id: 'premium',
      title: 'B2C – Business to Consulting',
      bg: 'bg-green-50',
      border: '',
      color: 'text-green-900',
      items: [
        'Laufende Finanzbuchhaltung',
        'Kontierung und Verbuchung sämtlicher Geschäftsvorfälle',
        'Abschreibungen im Rahmen der laufenden Buchhaltung',
        'Rückstellungen und Abgrenzungen im Rahmen der Buchführung',
        'Monatliche und quartalsweise Auswertungen (BWA, SuSa, Liquidität)',
        'Kosten‑ und Ergebnisrechnung',
        'Vorbereitung von Monats‑, Quartals‑ und Jahresabschlüssen',
        'Abschlussunterlagen zur Weiterverarbeitung durch Steuerberater oder Wirtschaftsprüfer'
      ],
      subtitle:
        'Für komplexe Fälle – wo Standardtools scheitern.'
    }
  ]

  const processSteps = [
    { step: '1', title: 'Daten‑Upload', desc: 'Portal/Excel – sicher & einfach' },
    { step: '2', title: 'Prüfung & Abrechnung', desc: 'schnell. – automatisiert + geprüft' },
    { step: '3', title: 'Export & Übermittlung', desc: 'Elster/DEÜV – fehlerfrei' },
    { step: '4', title: 'Lohnsteuerabrechnung', desc: 'Digital/postal – vollständig' }
  ]

  const vorteile1 = [
    { title: 'Fehlerfreiheit', desc: 'Automatisierte Checks + manuelle Expertise (0,1% Fehlerquote)' },
    { title: 'Kostenersparnis', desc: 'Bis 30% günstiger als interne Buchhaltung' },
    { title: 'Zeitersparnis', desc: 'Sie kümmern sich ums Kerngeschäft, wir um Löhne' },
    { title: 'Compliance', desc: 'GoBD, DSGVO, 2026‑Gesetze (Mindestlohn 13,90 €)' },
    { title: 'Digital', desc: 'Mandantenportal, eAU, Sofortmeldungen' }
  ]

  const vorteile2 = [
    'DATEV‑kompatibel (kein eigener Zugang nötig)',
    'ELSTER/DEÜV automatisiert',
    'Sicheres Portal (Upload, Zugriff Mitarbeiter)',
    'Personalkosten‑Reports & Statistiken',
    'Backup bei Krankheit/Ausfall'
  ]

  const faqs = [
    {
      question: 'Benötige ich DATEV‑Zugang?',
      answer:
        'Nein – wir arbeiten mit CSV/XML und importieren nahtlos in Ihr System.'
    },
    {
      question: 'Wie schnell sind Abrechnungen fertig?',
      answer:
        'Standardfälle in der Regel innerhalb von 48 Stunden, Premium‑Fälle nach Absprache.'
    },
    {
      question: 'Ab welcher Mitarbeiterzahl lohnt Outsourcing?',
      answer:
        'Ab 3–5 MA – bei uns Staffelpreise ab 12 €/MA.'
    },
    {
      question: 'Sind 2026‑Änderungen berücksichtigt?',
      answer:
        'Ja – Mindestlohn 13,90 €, Minijob 603 €, alle Updates inklusive.'
    }
  ]

  const [openFaq, setOpenFaq] = useState(null)

  return (
    <>
      <Helmet>
        <title>Leistungen | Payroll Expert</title>
        <meta name="description" content="Unsere Leistungen: Lohnabrechnung, Beratung und Service für Unternehmen und Steuerkanzleien." />
      </Helmet>
      <section className="max-w-6xl mx-auto py-20 px-6">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-blue-900 to-blue-700 text-white py-20 px-8 rounded-2xl mb-16 text-center">
        <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
          Professionelle Lohnbuchhaltung
          <span className="block text-2xl mt-2 text-yellow-300">
            – Spezialisiert auf alle Fälle
          </span>
        </h1>
        <p className="text-xl md:text-2xl mb-10 max-w-4xl mx-auto leading-relaxed">
          15+ Jahre Expertise in komplexer Lohnabrechnung. DATEV‑kompatibel, GoBD‑sicher, flexibel für
          Steuerkanzleien & KMU. Sparen Sie Zeit und Kosten – ab 12 € pro Mitarbeiter.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href="#pakete"
            className="bg-yellow-500 text-blue-900 px-10 py-5 rounded-xl font-bold text-xl hover:bg-yellow-400 transition-all shadow-lg hover:shadow-xl"
          >
            Pakete entdecken
          </a>
          <Link
            to="/contact"
            className="border-2 border-white px-10 py-5 rounded-xl font-bold text-xl hover:bg-white hover:text-blue-900 transition-all"
          >
            Kostenloses Angebot
          </Link>
        </div>
      </div>

      {/* Pakete */}
      <section id="pakete" className="mb-20">
        <h2 className="text-4xl font-bold text-gray-900 text-center mb-16">
          Unsere Leistungspakete
        </h2>
        <div className="grid md:grid-cols-3 gap-8">
          {tabs.map((tab) => (
            <div
              key={tab.id}
              id={tab.id}
              className={`p-8 rounded-2xl shadow-xl hover:shadow-2xl transition-all cursor-pointer ${tab.bg} ${tab.border}`}
              onClick={() => {
                setActiveTab(tab.id)
                window.location.hash = tab.id
              }}
            >
              <h3 className={`text-2xl font-bold mb-6 ${tab.color}`}>
                {tab.title}
              </h3>
              <ul className="space-y-4 mb-6">
                {tab.items.map((item, idx) => (
                  <li key={idx} className="flex items-start group">
                    <span className="text-yellow-500 text-2xl mr-4 flex-shrink-0 mt-0.5">
                      ✓
                    </span>
                    <span className="text-gray-700 leading-relaxed group-hover:text-blue-900 transition-colors">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
              <p
                className={`text-sm font-medium italic ${
                  tab.color === 'text-green-900' ? 'text-green-800' : 'text-gray-600'
                }`}
              >
                {tab.subtitle}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* Prozess */}
      <section className="mb-20">
        <h2 className="text-4xl font-bold text-gray-900 text-center mb-16">
          Unser bewährter 4‑Schritte‑Prozess
        </h2>
        <div className="grid md:grid-cols-4 gap-8 max-w-5xl mx-auto">
          {processSteps.map((step, idx) => (
            <div key={idx} className="text-center group">
              <div className="w-20 h-20 bg-gradient-to-r from-blue-500 to-blue-600 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg group-hover:scale-110 transition-all">
                <span className="text-2xl font-bold text-white">
                  {step.step}
                </span>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-2">
                {step.title}
              </h4>
              <p className="text-gray-600">{step.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Vorteile */}
      <section className="mb-20">
        <h2 className="text-4xl font-bold text-gray-900 text-center mb-16">
          Was Sie konkret gewinnen
        </h2>
        <div className="grid md:grid-cols-2 gap-12 max-w-6xl mx-auto">
          <div>
            <h3 className="text-2xl font-bold text-blue-900 mb-8">
              Ihre Vorteile
            </h3>
            <div className="space-y-6">
              {vorteile1.map((vorteil, idx) => (
                <div key={idx} className="flex items-start">
                  <span className="text-yellow-500 text-2xl mr-4 mt-1 flex-shrink-0">
                    ✓
                  </span>
                  <div>
                    <h4 className="font-bold text-gray-900 text-lg">
                      {vorteil.title}:
                    </h4>
                    <p className="text-gray-700">{vorteil.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div>
            <h3 className="text-2xl font-bold text-blue-900 mb-8">
              Technische Highlights
            </h3>
            <ul className="space-y-4 text-lg">
              {vorteile2.map((item, idx) => (
                <li key={idx} className="flex items-center">
                  <span className="text-yellow-500 text-xl mr-4">✓</span>
                  <span className="text-gray-700">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-gradient-to-r from-blue-900 to-blue-700 text-white py-20 px-8 rounded-2xl text-center mb-16">
        <h2 className="text-4xl font-bold mb-6">
          Bereit für sorgenfreie Lohnabrechnung?
        </h2>
        <p className="text-xl mb-10 max-w-2xl mx-auto leading-relaxed">
          Kostenloses Probemandat oder 15‑Minuten‑Beratung. Starten Sie noch heute!
        </p>
        <div className="flex flex-col sm:flex-row gap-6 justify-center">
          <Link
            to="/contact"
            className="bg-yellow-500 text-blue-900 px-12 py-6 rounded-xl font-bold text-2xl hover:bg-yellow-400 shadow-xl hover:shadow-2xl transition-all"
          >
            Jetzt anfragen
          </Link>
          <a
            href="#pakete"
            className="border-4 border-yellow-400 px-12 py-6 rounded-xl font-bold text-xl hover:bg-yellow-400 hover:text-blue-900 transition-all"
          >
            Pakete vergleichen
          </a>
        </div>
      </section>

      {/* FAQ */}
      <section>
        <h2 className="text-4xl font-bold text-gray-900 text-center mb-12">
          Häufige Fragen
        </h2>
        <div className="max-w-4xl mx-auto space-y-4">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-white border-2 border-gray-200 rounded-xl p-6 hover:shadow-lg transition-all cursor-pointer"
              onClick={() => setOpenFaq(openFaq === idx ? null : idx)}
            >
              <div className="flex items-center justify-between mb-2">
                <h4 className="text-xl font-bold text-gray-900">
                  {faq.question}
                </h4>
                <span
                  className={`text-2xl transition-transform ${openFaq === idx ? 'rotate-180' : ''}`}
                >
                  ▼
                </span>
              </div>
              {openFaq === idx && (
                <p className="text-gray-700 mt-4 pl-1">{faq.answer}</p>
              )}
            </div>
          ))}
        </div>
      </section>
      </section>
    </>
  )
}

export default Services
